/* eslint-disable */
// Cross-surface "open this LTD" bridge (LTD global-search group). Mirrors lensOpenBridge.js exactly:
// dependency-free so the global ⌘K search can import it without pulling the lazy Lens Data Base chunk
// into the main bundle. requestOpenLtd stashes the ltd_code (survives the cold-navigation race where
// LensBankPage isn't mounted yet) AND fires the 'open_ltd' event (fast path when the page is already
// mounted). LensBankPage consumes both: it listens for the event, and on mount drains any pending code
// via peek/clear, then hands the code to LensDevBoard which resolves it → tab + modal once rows load.
let _pending = null;

export function requestOpenLtd(ltdCode) {
  _pending = ltdCode || null;
  try { window.dispatchEvent(new CustomEvent('open_ltd', { detail: { ltd_code: ltdCode } })); } catch (_) {}
}
export const peekPendingLtd = () => _pending;
export const clearPendingLtd = () => { _pending = null; };
